import { isEmpty, swalError } from "@unisearch/helpers";
import React, { useEffect, useState } from "react";
import API from "@unisearch/helpers/api";
import { useAuthActions, useSystemActions } from "@_recoil/_actions";
import { authAtom } from "@_recoil/_state";
import { useRouter } from "next/router";
import { FaRegBookmark, FaBookmark } from "react-icons/fa";
import { useRecoilValue } from "recoil";
import styles from "./actions.module.scss";
import { ImSpinner8 } from "react-icons/im";

export const BookmarkAction = ({
  customClasses,
  referance,
  referanceId,
  is_bookmarked,
  showText = true,
  getReadingList = false,
}) => {
  const [profileInfo, setProfileInfo] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();
  const systemActions = useSystemActions();
  const authActions = useAuthActions();
  const profileInfos = useRecoilValue(authAtom);

  //referanceItems =  (blog,page )

  useEffect(() => {
    //remove redirect url
    systemActions.removeReturnUrl();
  }, [systemActions]);
  useEffect(() => {
    if (profileInfos) {
      setProfileInfo(profileInfos);
    }
  }, []);
  //Handle Bookmarke
  const handleBookmark = async () => {
    if (profileInfo && profileInfo.userTypeSlug === "student") {
      setIsLoading(true);
      const payload = {
        readingType: referance,
        referenceId: referanceId,
      };

      await API.post(`/student/reading-list`, payload).then(async (resp) => {
        if (!resp.error && resp.data) {
          await authActions.getProfile();
          setIsLoading(false);
          if (getReadingList) getReadingList();
        } else {
          swalError(resp.error);
          setIsLoading(false);
        }
      });
      // } else if (profileInfo && profileInfo.userTypeSlug !== "student") {
      //   return swalError("You are not sutdents", "Sorry!");
    } else {
      systemActions.setReturnUrl(router.asPath);
      await router.push({ pathname: "/signin" });
    }
  };

  return (
    <>
      {is_bookmarked ? (
        <div
          className={`${styles.bookmarke_wrapper} ${
            customClasses?.root ? customClasses?.root : ""
          }`}
        >
          <button
            className={`${styles.btn_bookmark} ${
              is_bookmarked ? styles.active : ""
            } ${customClasses?.btnClass ? customClasses?.btnClass : ""}`}
            onClick={() => handleBookmark()}
          >
            {!isLoading && (
              <FaBookmark
                className={`${styles.reg_bookmark}`}
                style={{ color: "#f47f20" }}
              />
            )}

            {referanceId && isLoading && (
              <ImSpinner8 className={`${styles.icon_spin}`} />
            )}
            {showText && <span>Bookmarked</span>}
          </button>
        </div>
      ) : (
        <div
          className={`relative ${styles.bookmarke_wrapper} ${
            customClasses?.root ? customClasses?.root : ""
          }`}
        >
          <button
            className={`${styles.btn_bookmark} ${
              customClasses?.btnClass ? customClasses?.btnClass : ""
            }`}
            onClick={() => handleBookmark()}
          >
            {!isLoading && (
              <FaRegBookmark className={`${styles.reg_bookmark}`} />
            )}

            {referanceId && isLoading && (
              <ImSpinner8 className={`${styles.icon_spin}`} />
            )}
            {showText && <span>Add to Bookmark</span>}
          </button>

          {isEmpty(profileInfo) && (
            <div className={`uni-tooltip`}>
              Please Login <br /> to perform this action
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default BookmarkAction;
